module.exports = __webpack_public_path__ + "6220dab1ee02f3d37605184a44216809.svg";